import api from './api';

export type KpiBulkEditPayload = {
  ids?: string[];
  applyToFiltered?: boolean;
  filters?: {
    origin?: string;
    status?: string;
    tag?: string;
    search?: string;
  };
  addTags?: string[];
  removeTags?: string[];
  status?: 'ACTIVE' | 'INACTIVE';
  frequency?: string;
};

export async function bulkEditKpis(payload: KpiBulkEditPayload): Promise<{
  updated: number;
  skipped: number;
}> {
  const response = await api.post('/kpis/bulk', payload);
  return response.data?.data || { updated: 0, skipped: 0 };
}
